module.exports = __webpack_public_path__ + "img/export.b309e2b9.svg";